import { ColumnDef } from "@tanstack/react-table";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { formatDateTimeWithZone, formatRelativeDate } from "@/core/utils/date";
import { CustomerWithReferralsAndPayouts } from "@/customer/customer";

export const JoinedCol = (): ColumnDef<CustomerWithReferralsAndPayouts> => ({
  header: "Joined",
  accessorKey: "created_at",
  cell: ({ row }) => {
    const createdAt = row.original.created_at;
    return (
      <Tooltip>
        <TooltipTrigger render={<span />}>
          {formatRelativeDate(createdAt)}
        </TooltipTrigger>
        <TooltipContent>{formatDateTimeWithZone(createdAt)}</TooltipContent>
      </Tooltip>
    );
  },
});
